/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordIndices } from "./RecordIndices";
export const GetRecordIndicesResponse = core.serialization.list(RecordIndices);
